import { DisciplineLiveStatus } from '@om-fe/models';
import { MatchListStoreModel } from '../../utils/match-list-models';
import { AppAction } from '@om-fe/store';
export const slicePrefix = 'match-of-the-day';

export const MATCH_OF_THE_DAYMATCH_AGGREGATOR_GROUPS_OVERVIEW_PATH: string = 'next-matches-aggregator-groups-overview-top-bets-by-dates/:disciplineId/:dateRange/:liveStatus/:limitNumberOfEvents/:marketGroupsOverviewIds';

export interface MatchOfTheDayMatchListStoreModel extends MatchListStoreModel {
    readonly ready: boolean;
    readonly isLoadingMoreData: boolean;
    readonly isLoadingData: boolean;
    readonly disciplineId?: string;
    readonly mainMarketsLimit?: number;
    readonly limit: number;
    readonly totalRecords: number;
    readonly marketGroupsOverviewIds?: string;
    readonly locationId?: string;
    readonly eventCategoryId?: string;
    readonly dateRange?: string | undefined;
    readonly liveStatus?: DisciplineLiveStatus | undefined;
}

export enum MatchOfTheDayMatchListActions {
    SetLoadingData = 'sports:match-of-the-day-match-list:set-loading-data',
    SetFilterData = 'sports:match-of-the-day-match-list:set-match-list-filter-data',
}

export interface MatchOfTheDayMatchListSetLoadingData extends AppAction<MatchOfTheDayMatchListActions.SetLoadingData> {
    readonly meta: {
        readonly slice: string;
    };
    readonly payload: {
        readonly isLoadingMoreData: boolean;
    };
}

export interface MatchOfTheDayMatchListSetFilterDataAction extends AppAction<MatchOfTheDayMatchListActions.SetFilterData> {
    readonly meta: {
        readonly slice: string;
    };
    readonly payload: {
        readonly limit: number;
        readonly disciplineId: string;
        readonly mainMarketsLimit: number | undefined;
        readonly marketGroupsOverviewIds?: string;
        readonly locationId?: string;
        readonly eventCategoryId?: string;
        readonly liveStatus?: DisciplineLiveStatus | undefined;
        readonly dateRange?: string;
    };
}

export interface MatchOfTheDayMatchListTopic {
    readonly path: string;
    readonly params: {
        readonly disciplineId?: string;
        readonly nrOfMarkets: number;
        readonly limitNumberOfEvents: number;
        readonly locationId?: string;
        readonly eventCategoryId?: string;
    };
}

export interface MatchOfTheDayMatchListGroupsOverviewTopic {
    readonly path: string;
    readonly params: {
        readonly disciplineId?: string;
        readonly limitNumberOfEvents: number;
        readonly marketGroupsOverviewIds?: string;
        readonly locationId?: string;
        readonly eventCategoryId?: string;
        readonly dateRange?: string | undefined;
        readonly liveStatus?: DisciplineLiveStatus;
    };
}